import type { ChatRoom } from 'models';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, EntitySnippet, Flex, GroupLineIcon, InformationLineIcon } from 'ui';
import { useGroupChatRoomInfo } from '../hooks';
import { ChatGroupInfoModal } from './chat-group-info-modal';

type P = {
  chatroom: ChatRoom;
  onChatDeleted: () => Promise<void>;
};

const AVATAR_SIZE = 40;

const ChatGroupHeader = ({ chatroom, onChatDeleted }: P) => {
  const { t } = useTranslation();
  const { membersCount, name } = useGroupChatRoomInfo(chatroom);
  const [isInfoModalOpened, setIsInfoModalOpened] = useState(false);

  return (
    <>
      <Flex align="center" className="chat-header" justify="space-between">
        <EntitySnippet
          avatarProps={{
            icon: <GroupLineIcon type="dark-default" />,
            size: AVATAR_SIZE,
          }}
          descriptionProps={{ children: t('membersCount', { count: membersCount }) }}
          titleProps={{
            children: name,
            ellipsis: { tooltip: name },
            weight: 'medium',
          }}
        />
        <Button
          icon={<InformationLineIcon />}
          onClick={() => {
            setIsInfoModalOpened(true);
          }}
          type="text"
        />
      </Flex>
      <ChatGroupInfoModal
        chatroom={chatroom}
        isOpened={isInfoModalOpened}
        onChatDeleted={onChatDeleted}
        onClose={() => {
          setIsInfoModalOpened(false);
        }}
      />
    </>
  );
};

export default ChatGroupHeader;
